var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1 5.7C4.1 3.3804 5.9804 1.5 8.3 1.5C10.6196 1.5 12.5 3.3804 12.5 5.7V6.50523C12.6978 6.54858 12.8877 6.6117 13.0712 6.70518C13.598 6.97363 14.0264 7.40197 14.2948 7.92883C14.4679 8.26856 14.5369 8.63025 14.5691 9.02372C14.6 9.40256 14.6 9.8676 14.6 10.4311V11.4689C14.6 12.0324 14.6 12.4974 14.5691 12.8763C14.5369 13.2697 14.4679 13.6314 14.2948 13.9712C14.0264 14.498 13.598 14.9264 13.0712 15.1948C12.7314 15.3679 12.3697 15.4369 11.9763 15.4691C11.5974 15.5 11.1324 15.5 10.5689 15.5H6.03111C5.46762 15.5 5.00256 15.5 4.62372 15.4691C4.23026 15.4369 3.86856 15.3679 3.52883 15.1948C3.00197 14.9264 2.57363 14.498 2.30518 13.9712C2.13208 13.6314 2.06308 13.2697 2.03094 12.8763C1.99998 12.4974 1.99999 12.0324 2 11.4689V10.4311C1.99999 9.86761 1.99998 9.40255 2.03094 9.02372C2.06308 8.63025 2.13208 8.26856 2.30518 7.92883C2.57363 7.40197 3.00197 6.97363 3.52883 6.70518C3.7123 6.6117 3.90218 6.54858 4.1 6.50523V5.7ZM11.1 5.7V6.40114H5.5V5.7C5.5 4.1536 6.7536 2.9 8.3 2.9C9.8464 2.9 11.1 4.1536 11.1 5.7ZM9 10.25C9 9.8634 8.6866 9.55 8.3 9.55C7.9134 9.55 7.6 9.8634 7.6 10.25V11.65C7.6 12.0366 7.9134 12.35 8.3 12.35C8.6866 12.35 9 12.0366 9 11.65V10.25Z",
    fill: "#0D121C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLock);
export default __webpack_public_path__ + "static/media/fullLock.65792a9dc0b72f38ecc458bcc43a3501.svg";
export { ForwardRef as ReactComponent };